<template>
  <div class="videos"> 
    <template>
      <v-container class="grey lighten-5">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h5>Buscar:</h5>
            <input type="text" placeholder="Escribe un producto" v-model="sword" v-on:keyup.13="getBreadcrumps(sword)">
          </v-col>
        </v-row>
      </v-container>
    </template>


    <v-card
        flat
        class="py-12"
      >
        <v-card-text >
          <v-row class="text-right" justify="center" >        
            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
            >

            <template>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }"> 
                <v-btn
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="600px"                 
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="green"            
                        v-bind="attrs"
                        v-on="on"
                        plain
                      >
                        <!-- 
                          <v-icon>add</v-icon>
                          -->
                        <v-icon>post_add</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                          <span class="headline">Nuevo Video</span>
                          <v-btn
                            class="headline"
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-container>  
                            <MessageForm :submitForm="AddMessage" buttonText="Guardar" />            
                          </v-container>
                          
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>          
                          <small style="color:red;">*Campos Obligatorios</small>
                          <!-- <v-btn 
                            color="blue darken-1"
                            text
                            v-on:click="submit"><v-icon>save</v-icon>
                          </v-btn>         -->
                        </v-card-actions>
                      </v-card>
                      </v-dialog>
                </v-btn>                
              </template>
              <span>Agregar Nuevo Tip</span>
            </v-tooltip>
        </template>
        <!-- FIN Dialog para agregar --> 
                             
                      
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">              
                    <v-btn
                      @click="$router.back()" 
                      color="primary darken-2"               
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon>arrow_back</v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar a la Página Anterior</span>
                </v-tooltip>
            </template>
              
              
            </v-btn-toggle>
          </v-row>
      </v-card-text>
    </v-card>

   <div>
    <table class="table table-striped">
     <thead class="thead-dark">
      <tr><th v-for="thead in theader" :key="thead.id">{{thead.text}}</th></tr>               
     </thead>
     <tr v-for="row in videos" :key="row">          
       <td>
         <!-- 
         <button v-on:click="deleteFriend(row.id, i)">x</button>
         -->
        <v-btn v-on:click="editRow = row.id" icon>
           <v-icon>edit</v-icon>
         </v-btn>
        <!-- <v-btn v-on:click="sendText(row.id)" icon>
          <v-icon>send</v-icon>
        </v-btn> -->
       </td>      
      <td>
        <div v-if="editRow === row.id">
           
            <v-text-field
                      v-model="row.autor"
                      placeholder="Autor"
                      v-on:keyup.13="updateRow(row)"
            ></v-text-field>
            <v-text-field
                      v-model="row.title"
                      placeholder="Titulo"
                      v-on:keyup.13="updateRow(row)"
            ></v-text-field>
            
            <v-text-field
                      v-model="row.key"
                      placeholder="Key Video"
                      v-on:keyup.13="updateRow(row)"
            ></v-text-field>
          <!-- <v-combobox
            v-model="row.canal"
            :items="itemsCanal"
            label="Selecciona un Canal"
          ></v-combobox>
          <v-combobox
            v-model="row.type"
            :items="itemsType"
            label="Selecciona un Tipo"
          ></v-combobox>
          <v-combobox
            v-model="row.status"
            :items="itemsStatus"
            label="Selecciona un Status"
          ></v-combobox> -->
          <!-- 
            <ejs-combobox v-on:keyup.13="updateRow(row)"  :dataSource='dataCanal' :fields='dataFCanal' placeholder='Seleccione un canal' popupWidth="250px">
            </ejs-combobox>
            <ejs-combobox v-on:keyup.13="updateRow(row)" v-model="row.type" :dataSource='dataItem' :fields='dataFields' placeholder='Seleccione un tipo' popupWidth="250px">            
            </ejs-combobox>
            <ejs-combobox v-on:keyup.13="updateRow(row)" v-model="row.status" :dataSource='dataStatus' :fields='dataFStatus' placeholder='Seleccione un status' popupWidth="250px">
            </ejs-combobox>           
          -->
          <v-btn v-on:click="updateRow(row)" class="green">Actualizar</v-btn>
        </div>
        <div v-else>
          
          <small>{{row.autor}}</small><br>
          {{row.title}}
        </div>        
      </td>
      <td>https://youtu.be/{{row.key}}</td>      
      <td>{{row.created_at}}</td>
      <td>{{row.updated_at}}</td>    
     </tr>
   </table>          
   </div>          
        
    <!--    
    </v-flex>
  </v-layout>
</v-container>
 -->


  </div>
</template>


<script>
import{ mapMutations,mapState } from "vuex";
//import FieldSearch from '@/components/FieldSearch.vue'
import MessageForm from "@/components/VideoCreate";
import icheckApi from '@/services/icheckApi';


export default {
  name: 'videos',
  computed:{
        ...mapState(['videos'])
  },
  components: {
      //FieldSearch,
      MessageForm,
  },
  data(){
     return{
      sword:"",
      attribute: {sword: '',limit: 7},
      sfecha:new Date().toISOString().substr(0,10),
      dialog:"",
      editRow:null,      
      itemsStatus: [
          'Pendiente',
          'Enviado',
      ],            
      itemsCanal: [
          '@DevCloudBits',
          '@iOnOffMX',
      ],                  
      itemsType: [
          'System',
          'Telegram',
      ],           
      
      theader: [
        { text: 'Acción', value: 'canasta_basica' },
        {
          text: 'Autor',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        { text: 'Key', value: 'canal' },
        { text: 'Fecha Registro', value: 'created_at' },
        { text: 'Fecha Actualización', value: 'updated_at' },
      ],
    }
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
     updateRow(row) {      
      try{        
        this.showLoading({titulo:"Accediendo información",color:"warning"})                  
          // let datos=icheckApi().post(`/videos/update/${row.id}`,JSON.stringify(row));
        // let datos=icheckApi().post(`/videos/update`,JSON.stringify(row));
        icheckApi().post(`/videos/update`,JSON.stringify(row)).then((response)=>{       
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              // this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error"); 
              this.$swal("Error!",response.data.message, "error"); 
            }                                   
        });

          // console.log(datos);
        }catch(error){
          console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", "Se actualizó la información", "success");
        } 
    },
    async getVideos(){
      try{        
        this.showLoading({titulo:"Accediendo información",color:"primary"})
        await this.$store.dispatch('loadVideos',this.attribute);        
      }catch(error){
        //console.log(error);
      }  finally{
        this.hiddenLoading()
      } 
    }, 
    async getBreadcrumps(sword){
      this.attribute.sword=sword;
      this.getVideos();

           
    }
  },
  created(){
    this.changeBreadcrumbs({
        page:"Videos",
        title:"Lista de Videos",
        subtitle:"primary",
        description:"En esta lista encontrará todos los videos dados de alta en el sistema desde el principio de los tiempos"
    });  
    this.getBreadcrumps(this.sword)
  }
}
</script>